import type { DataCollection } from "@sentry/core";

/**
 * What the Sentry SDK may collect on its own, for every runtime's init.
 *
 * On is what makes a report reproducible: who hit the error, their cookies,
 * the headers and query string (the SDK filters sensitive keys and tokens out
 * of all three), the body of the incoming request — the form a failing server
 * action was given — and the local variables in each frame of the stack.
 *
 * Off is what a report has no use for: the bodies of outgoing requests and
 * their responses (API payloads), the agent's prompts and replies, bound
 * database parameters, and queue payloads — volume, not debugging. What a
 * report carries on purpose rides `reportError`'s context, which this does
 * not gate.
 */
export const SENTRY_DATA_COLLECTION: DataCollection = {
  userInfo: true,
  cookies: true,
  httpBodies: ["incomingRequest"],
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  stackFrameVariables: true,
};
